<!--
 * @author xuyiyuan
 * @date 2023-08-15 15:11
 * @description  公司主体
-->
<template>
  <lsTableLayout>
    <div slot="table">
      <ls-api-table
        ref="dataTable"
        :columns="columns"
        :tableProps="tableProps"
        :scroll="{ fixScreen: true }"
        :toolBox="{
                density: true, // 传入String时 初始化默认表格密度
                fullScreen: false,  // 是否需要全屏
                configKey: $TableKey.COMPANY_LIST, // 表格方案配置唯一值
              }"
      >
        <!--公司信息-->
        <div slot="companyInfo" slot-scope="{ text, record }">
          <div class="over-text">
            <div>公司全称：{{ record.companyName }}</div>
            <div>公司简称：{{ record.companyShortName }}</div>
            <div>公司编码：{{ record.companyNo }}</div>
          </div>
        </div>
        <!--公司地址-->
        <template slot="companyAddress" slot-scope="{ record }">
          <div class="over-text">
            <div>公司地址：{{ record.companyAddress }}</div>
            <div>电话：{{ record.companyPhone }}</div>
          </div>
        </template>
        <!--开户行-->
        <template slot="account" slot-scope="{ text, record }">
          <div>开户行：{{ record.depositBank }}</div>
          <div>账号：{{ record.bankAccount }}</div>
        </template>
        <!--操作人-->
        <template slot="operator" slot-scope="{ record }">
          <div>最后修改人：{{ record.dataModifyUserName }}</div>
          <div>
            最后修改时间：{{ record.updateTime && $moment(record.updateTime).format('YYYY-MM-DD HH:mm') }}
          </div>
        </template>
        <!-- 插槽指向状态 -->
        <template slot="status" slot-scope="{ text }">
          <a-badge :status="text | statusTypeFilter" :text="text | statusFilter" />
        </template>
      </ls-api-table>
    </div>
  </lsTableLayout>
</template>

<script>
import { apiTSysCompanySubjectList } from '@/api/mdm/supplychain/company'
import { generateLsTableResData } from '@/utils/util.js'

const statusMap = {
  1: {
    status: 'processing',
    text: '启用'
  },
  0: {
    status: 'default',
    text: '停用'
  }
}

export default {
  name: 'Company',
  components: {},
  data () {
    return {
      // 表格配置
      tableProps: {
        requestApi: generateLsTableResData(apiTSysCompanySubjectList, true),
        pageCurrent: true
      },
      // 表头
      columns: [
        {
          title: '公司信息',
          dataIndex: 'companyInfo',
          scopedSlots: { customRender: 'companyInfo' }
        },
        {
          title: '纳税人识别号',
          dataIndex: 'taxNumber'
        },
        {
          title: '公司地址、电话',
          dataIndex: 'companyAddress',
          scopedSlots: { customRender: 'companyAddress' }
        },
        {
          title: '开户行、账号',
          dataIndex: 'account',
          scopedSlots: { customRender: 'account' }
        },
        {
          title: '操作人',
          dataIndex: 'operator',
          scopedSlots: { customRender: 'operator' }
        },
        {
          title: '状态',
          dataIndex: 'status',
          width: 80,
          scopedSlots: { customRender: 'status' }
        }
      ],
      // table加载绑定
      tableLoading: false,
      // 表格数据
      roleList: [],
      // 查询参数
      queryParams: {
        pageNum: 1,
        pageSize: 10
      }
    }
  },
  mounted () {
    this.onSearch();
  },
  // 状态过滤
  filters: {
    statusFilter (type) {
      return statusMap[type].text
    },
    statusTypeFilter (type) {
      return statusMap[type].status
    }
  },
  methods: {
    // 表单搜索
    onSearch (values = {}) {
      const params = { ...values };
      delete params.searchFormLabel;
      this.$refs.dataTable.searchParams = params;
      this.$refs.dataTable.getData();
    }
  }
}
</script>

<style scoped lang="less">
.over-text {
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
